import { normalizePluBalanza } from '../pluBalanza';

export const KRETZ_PESO_PARSER_ID = 'kretz-peso';
export const KRETZ_PESO_PREFIX = '20';
export const KRETZ_PESO_LENGTH = 13;

/**
 * Kretz — etiqueta de peso variable (MVP).
 * Layout real en etiquetas Condinea/Kretz (13 dígitos):
 *   20 + PLU(4) + SEP(1, usualmente 0) + PESO gramos(5) + DV(1)
 * Ej: 2000360004500 → PLU 0036 → 00036, peso 00450 → 0.450 kg
 */
export function parseKretzPesoBarcode(rawCode) {
  const code = String(rawCode || '').replace(/\D/g, '');
  if (code.length !== KRETZ_PESO_LENGTH) return null;
  if (code.slice(0, 2) !== KRETZ_PESO_PREFIX) return null;

  const plu = normalizePluBalanza(code.slice(2, 6));
  const grams = parseInt(code.slice(7, 12), 10);
  if (!plu || Number.isNaN(grams)) return null;

  const weightKg = grams / 1000;

  return {
    parser: KRETZ_PESO_PARSER_ID,
    prefix: KRETZ_PESO_PREFIX,
    plu,
    weightGrams: grams,
    weightKg,
    checkDigit: code.slice(12, 13),
    barcode: code,
    /** Compat con flujo previo del cajero. */
    productCode: plu,
    grams
  };
}
